import type {
	FormValues,
	NormalizedFormValues,
	SignFormExperiments,
} from 'src/app/pages/petitionGamma/details/shared/types';

export function normalizeWhatsappCommsConsent(
	{ whatsappCommsConsentGiven }: Pick<FormValues, 'whatsappCommsConsentGiven'>,
	{ mobileOptIn }: SignFormExperiments,
): NormalizedFormValues['whatsappCommsConsent'] {
	return mobileOptIn.showOptInCheckbox && mobileOptIn.optInChannel === 'whatsapp'
		? {
				consentGiven: !!whatsappCommsConsentGiven,
				// phone_consent is in the user_service prefix safelist
				name: 'phone_consent_sign_form_whatsapp_updates',
				text: mobileOptIn.optInCopy,
			}
		: null;
}
